import React from "react";
import PropTypes from "prop-types";
import BlogRoll from "../BlogRoll";
import { PrimaryButton } from "../Buttons";

const NewsSection = ({ language, section }) => (
  <section className="section py-32">
    <div className="container">
      <h2 className="text-center">{section.title}</h2>
      <BlogRoll language={language} featuredPostsOnly={true} limit={4} />
      <div className="text-center mt-20">
        <PrimaryButton
          button={{
            text: "View all",
            url: `${language === "en" ? "" : ""}blog`,
          }}
        />
      </div>
    </div>
  </section>
);

NewsSection.propTypes = {
  language: PropTypes.string,
  section: PropTypes.object.isRequired,
};

export default NewsSection;
